import { IconArrowRight } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { orgHref } from '../lib/org';
import { PushToggle } from './PushToggle';
import { buttonClass } from './ui/Button';

// "How should we reach you?" — the onboarding notifications intro (arc 101 slice
// 09 task 57). Until now the ONLY way to enable Web Push was the easily-missed
// topbar ghost icon (AppShell.tsx); onboarding never mentioned channels at all.
// Shown on the terminal (done) screen, this states the always-on defaults (in-app
// bell + email) and surfaces the per-device push opt-in right when the account
// comes online, then hands off to the full Notifications settings home for the
// rest. Presenter — `PushToggle` owns the permission/subscribe state-machine and
// hides itself where push is unsupported, so this card
// never dead-ends: it degrades to "defaults + settings link". The settings link is
// a plain `<a>` (full nav) like its sibling done-card CTAs — leaving the funnel
// wants a fresh load, no stale onboarding state.
export function OnboardingReachYou(): JSX.Element {
  return (
    <div class="card card--footered onboarding__reach">
      <div class="card__header">
        <h2 class="card__title">{t('onboarding.reach_heading')}</h2>
        <p class="card__desc">{t('onboarding.reach_body')}</p>
      </div>

      <div class="card__content">
        <ul class="onboarding__reach-defaults">
          <li>{t('onboarding.reach_default_bell')}</li>
          <li>{t('onboarding.reach_default_email')}</li>
          <li>{t('onboarding.reach_default_push')}</li>
        </ul>
        <div class="onboarding__reach-push">
          <PushToggle />
          <span class="onboarding__reach-push-note">{t('onboarding.reach_push_note')}</span>
        </div>
      </div>

      <div class="card__footer">
        <a
          class={buttonClass({ variant: 'outline', size: 'sm' })}
          href={orgHref('/account/notifications')}
        >
          {t('onboarding.reach_settings_cta')}
          <IconArrowRight size="0.875rem" />
        </a>
      </div>
    </div>
  );
}
